export const DEFAULT_PARAMS = { limit: 10, offset: 0, sort: "name" };
